import EventApi from '@apis/event/EventApi';
import { createQueryKeys } from '@lukemorales/query-key-factory';
import { GetEventsParams } from '@models/event/request';

const eventQueries = createQueryKeys('events', {
  list: (params: GetEventsParams) => ({
    queryKey: [params],
    queryFn: () => EventApi.getEvents(params),
  }),
  detail: (eventId: string) => ({
    queryKey: ['detail', eventId],
    queryFn: () => EventApi.getEvent(eventId),
  }),
});

export default eventQueries;
